import axios from 'axios'
export default {
  state: {
    total: null,
    searchValue: '',
    page: 1,
    response: {
      subscribers: []
    },
    errors: {
      getSubscribers: null
    },
    loading: {
      getSubscribers: false
    }
  },
  mutations: {
    GET_SUBSCRIBERS_LIST_SUCCESS(state, payload) {
      state.response.subscribers = payload.subscribers
      state.total = payload.total
      state.errors.getSubscribers = null
      state.loading.getSubscribers = false
    },
    GET_SUBSCRIBERS_LIST_ERROR(state, error) {
      state.errors.getSubscribers = error
      state.loading.getSubscribers = false
    },
    CLEAR_SUBSCRIBERS(state) {
      state.response.subscribers = []
    },
    SET_SEARCH_VALUE(state, payload) {
      state.searchValue = payload
    },
    CLEAR_SEARCH_VALUE(state, payload) {
      state.searchValue = ''
    },
    SET_PAGE_NUMBER(state, payload) {
      state.page = payload
    },
    CLEAR_PAGE_NUMBER(state, payload) {
      state.page = 1
    }
  },
  actions: {
    GET_SUBSCRIBERS_LIST({ commit, state, dispatch }, data) {
      const sessionId = sessionStorage.getItem('token')
      state.loading.getSubscribers = true
      return axios({
        method: 'POST',
        url: `/api/CustomerRegistration/GetSubscribers/${sessionId}`,
        data
      })
        .then(response => {
          commit('GET_SUBSCRIBERS_LIST_SUCCESS', response.data)
        })
        .catch(error => {
          commit('GET_SUBSCRIBERS_LIST_ERROR', error.response.data.message)
          dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
        })
    },
    ADD_PAYMENT({ commit, dispatch, state }, payload) {
      const sessionId = sessionStorage.getItem('token')
      if (sessionId) {
        axios({
          method: 'POST',
          url: `/api/CustomerRegistration/AddPayment/${sessionId}`,
          data: payload
        })
          .then(response => {
            dispatch('NOTIFICATION', { open: true, color: 'success', text: 'Оплата прошла успешно.' })
            dispatch(
              'GET_SUBSCRIBERS_LIST',
              state.searchValue
                ? { innFilter: state.searchValue, nameFilter: state.searchValue, amount: 10, page: state.page }
                : { amount: 10, page: state.page }
            )
          })
          .catch(error => {
            dispatch('NOTIFICATION', { open: true, color: 'error', text: error.response.data.message })
          })
      }
    }
  }
}
